import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  badgeContainer: {
    height: theme.spacing(3),
    minWidth: theme.spacing(5),
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  badge: {
    background: theme.palette.error.main,
    color: "white",
    width: "min-content",
    minWidth: theme.spacing(3),
    height: theme.spacing(3),
    padding: 0,
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "150%",
  },
  badgeLabel: {
    padding: 0,
    fontSize: 12,
    lineHeight: 1,
  },
}));
